import Grid from '@mui/material/Grid';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(Grid)`
  position: relative;
  .title {
    font-weight: bold;
  }
`);
